import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "articles__img-box" }
const _hoisted_2 = {
  key: 0,
  class: "articles__play"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "articles__play-icon iconfont iaudio" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  crossorigin: "anonymous",
  class: "articles__img",
  alt: ""
}
const _hoisted_6 = { class: "articles__text-box" }
const _hoisted_7 = { class: "articles__text" }
const _hoisted_8 = { class: "articles__category card__category" }
const _hoisted_9 = { class: "articles__title card__title" }
const _hoisted_10 = { class: "articles__author card__author" }
const _hoisted_11 = { class: "articles__bottom-box" }
const _hoisted_12 = { class: "articles__date" }

import { computed } from 'vue'

import { ArticlesView, ArticleView } from '@/models/doc.article'

import FavoriteFlag from '@/app/components/listing/FavoriteFlag.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Card',
  props: {
    view: null,
    doc: null
  },
  setup(__props: any) {

const props = __props as {
  view: ArticlesView
  doc: ArticleView
};



const isCTA = computed(() => {
  return props.doc.title === 'CTA'
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (!_unref(isCTA))
    ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        to: __props.view.link(__props.doc),
        class: "articles__item"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (__props.doc.has_audio)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("img", _hoisted_5, null, 512), [
              [_directive_lazy, { src: __props.doc.cover_thumbnail }]
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("h5", _hoisted_8, _toDisplayString(__props.view.firstTag(__props.doc)), 1),
              _createElementVNode("h3", _hoisted_9, _toDisplayString(__props.doc.title), 1),
              _createElementVNode("h4", _hoisted_10, "By " + _toDisplayString(__props.doc.author), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("p", _hoisted_12, _toDisplayString(__props.doc.publisher.name) + " (" + _toDisplayString(__props.doc.original_publish_date.slice(0, 4)) + ") ", 1),
              _createVNode(FavoriteFlag, {
                class: "articles__collection collection",
                doc: __props.doc
              }, null, 8, ["doc"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["to"]))
    : _createCommentVNode("", true)
}
}

})